// src/shared/components/ui/StatCard.jsx
// ✅ بطاقة إحصاء موحدة — Modern Dark Ready
import React from 'react';
import styles from './StatCard.module.css';
import { formatNumber } from '../../utils/formatters';

/**
 * @param {string}  title
 * @param {number}  value
 * @param {string}  unit
 * @param {'default'|'primary'|'profit'|'success'|'expense'|'danger'|'warning'|'info'|'purple'} color
 * @param {React.ReactNode} icon
 * @param {number}  decimals
 * @param {boolean} clickable
 * @param {boolean} active
 * @param {Function} onClick
 */
const StatCard = ({
  title,
  value,
  unit      = '',
  color     = 'default',
  icon,
  decimals  = 2,
  clickable = false,
  active    = false,
  onClick,
}) => {
  const classes = [
    styles.card,
    styles[color] || styles.default,
    clickable ? styles.clickable : '',
    active    ? styles.active    : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} onClick={onClick} role={clickable ? 'button' : undefined}>
      {icon && <div className={styles.icon} aria-hidden="true">{icon}</div>}
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.value}>
          {formatNumber(value, decimals)}
          {unit && <span className={styles.unit}>{unit}</span>}
        </p>
      </div>
    </div>
  );
};

export default StatCard;